import Assurance from './servicePayloads/assurance';
import Bank from './servicePayloads/bank';
import Generic from './servicePayloads/generic';
import Activity from './servicePayloads/activity';
import Etudiant from "./servicePayloads/etudiant";
import OtherActivity from './servicePayloads/otherActivity';
import Pension from './servicePayloads/pension';
import Lease from './servicePayloads/lease';
import Ehpad from './servicePayloads/ehpad';
// import AddressInfo from './addressInfo';
import {FrenchTypes} from '../utils/connectionTypes';

export default function ServiceData(data){
    let service = data || {};
    this.id = service.id;
    this.userId = service.userId;
    this.serviceName = service.serviceName;
    this.serviceType = service.serviceType;
    this.serviceId = service.serviceId;
    this.customServiceDetails = service.customServiceDetails;
    this.payload = //service.serviceType === FrenchTypes.insurance ? new Assurance(service.payload):
			service.serviceType === FrenchTypes.bank
				? new Bank(service.payload)
				: service.serviceType === FrenchTypes.activity
				? new Activity(service.payload)
				: service.serviceType === FrenchTypes.etudiant
				? new Etudiant(service.payload)
				: service.serviceType === FrenchTypes.otherActivity
				? new OtherActivity(service.payload)
				: service.serviceType === FrenchTypes.pension
				? new Pension(service.payload)
				: service.serviceType === FrenchTypes.locataire
				? new Lease(service.payload)
				: service.serviceType === FrenchTypes.ehpad
				? new Ehpad(service.payload)
				: //    service.serviceType === FrenchTypes.homeInsurance ? new AddressInfo(service.payload):
				  new Generic(service.payload);
   this.position = service.position;
   this.lifeEvent = service.lifeEvent;
}